/**
 * Utilities for handling session storage operations
 */

/**
 * Clears the selectedCarrier from session storage if it exists
 * @returns {boolean} True if the item was found and removed, false otherwise
 */
export const clearSelectedCarrier = (): boolean => {
    if (sessionStorage.getItem("selectedCarrier")) {
        console.log("Clearing selectedCarrier");
        sessionStorage.removeItem("selectedCarrier");
        return true;
    }
    return false;
};
